import LoginPage from "./login/LoginPage";
import TenantSelectPage from "./tenantSelect/TenantSelectPage";
import { isRootDomain } from "../../utils/host";

const LoginGate = () => {
  return isRootDomain() ? <TenantSelectPage /> : <LoginPage />;
};

export default LoginGate;
